/**
 * @license
 * Copyright Alibaba.com All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

import Calendar from './calendar/ro_RO';
import DatePicker from './date-picker/ro_RO';
import Pagination from './pagination/ro_RO';
import TimePicker from './time-picker/ro_RO';

export default {
  locale: 'ro',
  Pagination,
  DatePicker,
  TimePicker,
  Calendar,
  global: {
    placeholder: 'SelecteazÄ'
  },
  Table: {
    filterTitle: 'FiltreazÄ',
    filterConfirm: 'OK',
    filterReset: 'ReseteazÄ',
    selectAll: 'SelecteazÄ pagina curentÄ',
    selectInvert: 'InverseazÄ pagina curentÄ',
    sortTitle: 'OrdoneazÄ',
    expand: 'Extinde rÃ¢ndul',
    collapse: 'MicÈoreazÄ rÃ¢ndul'
  },
  Modal: {
    okText: 'OK',
    cancelText: 'Anulare',
    justOkText: 'OK'
  },
  Popconfirm: {
    okText: 'OK',
    cancelText: 'Anulare'
  },
  Transfer: {
    titles: ['', ''],
    searchPlaceholder: 'CÄutare',
    itemUnit: 'element',
    itemsUnit: 'elemente'
  },
  Upload: {
    uploading: 'Se transferÄ...',
    removeFile: 'ÃnlÄturÄ fiÈierul',
    uploadError: 'Eroare la upload',
    previewFile: 'Previzualizare fiÈier'
  },
  Empty: {
    description: 'FÄrÄ date'
  },
  Icon: {
    icon: 'icon'
  },
  Text: {
    edit: 'editeazÄ',
    copy: 'copiazÄ',
    copied: 'copiat',
    expand: 'extinde'
  },
  PageHeader: {
    back: 'Ã®napoi'
  }
};
